import { render, staticRenderFns } from "./ShowcaseConsumer.vue?vue&type=template&id=5216a8b6&"
import script from "./ShowcaseConsumer.vue?vue&type=script&lang=js&"
export * from "./ShowcaseConsumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports